import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Producto from "./components/Producto";
import Beneficios from "./components/Beneficios";
import Testimonios from "./components/Testimonios";
import NosotrosPropuesta from "./components/NosotrosPropuesta";
import InstagramFeed from "./components/InstagramFeed";
import Contacto from "./components/Contacto";
import Footer from "./components/Footer";
import BotonFlotanteWhatsApp from "./components/BotonFlotanteWhatsApp";

const App = () => {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Producto />
        <Beneficios />
        <Testimonios />
        <NosotrosPropuesta />
        <InstagramFeed />
        <Contacto />
      </main>
      <Footer />
      <BotonFlotanteWhatsApp />
    </>
  );
};

export default App;
